import { object, string } from 'yup'
import { MultiStepSchema, StepSchema } from '../Types'
import { CaptionDetailsSchema, ImageSelectionSchema, meta, PurposeAndGoalsSchema, TemplateSchema } from './Common'

export const PostTypeSchema = object({
  kind_of_post: string().default('text').required(),
}).meta({
  title: 'Post Type',
  header: 'What kind of post do you want to make?',
  submitLabel: 'Refine Post Details',
}) as StepSchema

export const FlowCSchema = ({ generationType }: { generationType: string }) =>
  ({
    meta,
    steps: [
      PostTypeSchema,
      CaptionDetailsSchema({ generationType }).meta({
        previousLabel: 'Set Post Type',
        showAddImageButton: true,
        header: 'Refine post details',
      }),
    ],
  } as MultiStepSchema)

export const FlowCSchemaWithImage = ({ generationType }: { generationType: string }) =>
  ({
    meta,
    steps: [
      ...FlowCSchema({ generationType }).steps,
      ImageSelectionSchema.meta({
        previousLabel: 'Refine Post',
        submitLabel: 'Generate Post',
        videoConfirmLabel: 'Generate Post',
        header: 'Pick media',
        withBackArrow: true,
      }),
    ],
  } as MultiStepSchema)

export const FlowCSchemaVisual = ({ generationType, hidePostTypeStep = false }: { generationType: string; hidePostTypeStep?: boolean }) =>
  ({
    meta,
    steps: [
      ...(hidePostTypeStep ? [] : [PostTypeSchema]),
      PurposeAndGoalsSchema({ generationType }),
      TemplateSchema,
    ],
  } as MultiStepSchema)
